import api from "../utils/api";

// Returns { catalog: {fileName, importedAt, items} | null, mappings: [...] }
export async function fetchMapperData(type) {
  const { data } = await api.get(`/api/upc-mapping/${type}`);
  return {
    catalog: data?.catalog || null,
    mappings: data?.mappings || [],
  };
}

// Replaces the persisted Excel-derived catalog for this store + type.
export async function replaceCatalog(type, fileName, items) {
  const { data } = await api.put(`/api/upc-mapping/${type}/catalog`, { fileName, items });
  return data?.catalog || null;
}

export async function upsertMapping(type, externalId, scannedUpc, description = "") {
  const { data } = await api.put(`/api/upc-mapping/${type}/${encodeURIComponent(externalId)}`, {
    scannedUpc,
    description,
  });
  return data;
}

export async function clearMapping(type, externalId) {
  return upsertMapping(type, externalId, "");
}

// Removes a single catalog row and its associated scan mapping (if any).
export async function deleteItem(type, externalId) {
  const { data } = await api.delete(
    `/api/upc-mapping/${type}/item/${encodeURIComponent(externalId)}`
  );
  return data;
}

// Returns { [packUpc]: { entered, date, item, qty, amount, discount, basketId } }
// for the most recent SalesTransaction matching each pack UPC. Missing UPCs
// (no sales) are simply absent from the result map.
export async function fetchLatestSalesByPackUpc(type, packUpcs) {
  if (!Array.isArray(packUpcs) || !packUpcs.length) return {};
  const { data } = await api.post(`/api/upc-mapping/${type}/latest-sales`, { packUpcs });
  return data?.latestByPackUpc || {};
}

// Wipes both catalog and scans for this store + type.
export async function clearAllMappings(type) {
  const { data } = await api.delete(`/api/upc-mapping/${type}`);
  return data;
}
